import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "grid w-full gap-6 md:grid-cols-2" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  class: "inline-flex items-center justify-between w-full p-5 text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-primary peer-checked:border-primary peer-checked:text-primary hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700",
  for: "hosting-small"
}
const _hoisted_5 = { class: "block" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "inline-flex items-center justify-between w-full p-5 text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-primary peer-checked:border-primary peer-checked:text-primary hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700",
  for: "hosting-big"
}
const _hoisted_8 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("input", {
          id: "hosting-small",
          value: _ctx.modelValue,
          checked: "",
          class: "hidden peer",
          name: "hosting",
          type: "radio",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', 'device')))
        }, null, 40, _hoisted_3),
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'tablet-screen-button'] }),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full text-lg font-semibold" }, "Device", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-full text-sm" }, "Give user permission for a device", -1))
          ])
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("input", {
          id: "hosting-big",
          value: _ctx.modelValue,
          class: "hidden peer",
          name: "hosting",
          type: "radio",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', 'company')))
        }, null, 40, _hoisted_6),
        _createElementVNode("label", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'building'] }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-full text-lg font-semibold" }, "Company", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-full text-sm" }, " Give user permission for everything in company ", -1))
          ])
        ])
      ])
    ])
  ]))
}